/* eslint-disable import/first */
import React, { useEffect } from 'react'
import { InjectedFormProps, reduxForm, Field } from 'redux-form'
import { useDispatch, useSelector } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { Link } from 'react-router-dom'
import { translate } from '../../i18n'
import { getLoginLoading } from './login.selector'
import { IAppState } from '../../store/state.interface.web'
import { loginUser } from './index.reducer'
import { required, isValidEmail } from '../../../Web/common/validate'
import { FormField } from '../../../Web/components/FormField/FormField'
import LogoHeader from '../logoHeader'

const LoginForm: React.FC<
  RouteComponentProps & InjectedFormProps<{}, RouteComponentProps>
> = props => {
  // * variables decalaration
  const { handleSubmit } = props
  const dispatch = useDispatch()

  const loading = useSelector<IAppState, boolean>(getLoginLoading)
  const token = useSelector<IAppState, string>((state: IAppState) => state.login.token)

  useEffect(() => {
    if (token) {
      props.history.push('/dashboard')
    }
  }, [])

  const renderLoader = () => {
    if (loading) {
      return <em className="fas fa-circle-notch fa-spin ml-1" />
    }
  }

  const submitLogin = (submittedValues: any) => {
    dispatch(loginUser(submittedValues))
  }

  return (
    <>
      <div className="block-center wd-xxxl d-flex flex-column full-height justify-content-center">
        <div className="card card-flat">
          <LogoHeader />
          <div className="card-body">
            <p className="text-center  auth-title">
              {translate('login.title')}
            </p>
            <form className="mb-3 w-75 m-auto" name="formLogin" onSubmit={handleSubmit(submitLogin)}>
              <Field
                name="userName"
                component={FormField}
                type="email"
                label={``}
                placeholder={translate('login.emailPlaceholder')}
                required
                validate={[required, isValidEmail]}
                icon="fa-envelope"
              />{' '}
              <Field
                name="password"
                required
                component={FormField}
                type="password"
                placeholder={translate('login.passwordPlaceholder')}
                validate={[required]}
                label={''}
                icon="fa-lock"
              />
              <div className="clearfix">
                <div className="float-right">
                  <Link to="forgot-password" className="text-muted">
                    <span className="auth-subLinks">
                      {translate('login.forgotPassword')}
                    </span>
                  </Link>
                </div>
              </div>
              <button
                className="btn btn-block btn-primary mt-3"
                type="submit"
              >
                Login {renderLoader()}
              </button>
            </form>
          </div>
        </div>
        <div className="p-3 text-center">
          <span className="mr-2">&copy;</span>
          <span>{translate('authLayout.copyRights')}</span>
          <span className="mx-2"></span>
          <br />
          <span>{`Remote Patient Monitoring`}</span>
          <br />
          <span>{translate('authLayout.rightsReserved')}</span>
        </div>
      </div>
    </>
  )
}

export default reduxForm<{}, RouteComponentProps>({
  form: 'LoginForm',
  keepDirtyOnReinitialize: true
})(LoginForm)
